var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-card",
    {
      staticClass: "moulding-result",
      class: { selected: _vm.selected },
      attrs: { "no-body": "", "border-variant": _vm.selected ? "brand" : "" },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c("b-aspect", { attrs: { aspect: _vm.aspect } }, [
        _c("picture", [
          _c("source", {
            attrs: {
              type: "image/avif",
              srcset: _vm.moulding.chevronImages[320].avif,
            },
          }),
          _c("source", {
            attrs: {
              type: "image/webp",
              srcset: _vm.moulding.chevronImages[320].webp,
            },
          }),
          _c("img", {
            staticClass: "card-img-top p-1 chevron-image",
            staticStyle: { "max-width": "100%", height: "auto" },
            attrs: {
              src: _vm.moulding.chevronImages[320].jpg,
              lazy: "",
              alt: `Moulding ${_vm.moulding.itemCode} Chevron`,
              height: _vm.imgHeight,
            },
          }),
        ]),
      ]),
      _c("b-card-body", { staticClass: "p-2" }, [
        _c("p", { staticClass: "tag green" }, [
          _vm._v("£" + _vm._s(_vm.totalPrice)),
        ]),
        _c("span", { staticClass: "text-center" }, [
          _vm._v("Ref: " + _vm._s(_vm.moulding.itemCode)),
        ]),
      ]),
      _c(
        "b-card-footer",
        { staticClass: "p-2" },
        [
          _c(
            "b-row",
            { staticClass: "text-center", attrs: { "align-h": "center" } },
            [
              _c("b-col", { attrs: { cols: "auto" } }, [
                _c("p", { staticClass: "mb-0" }, [
                  _c("small", [
                    _vm._v("Width"),
                    _c("br"),
                    _vm._v(_vm._s(Math.round(_vm.moulding.width_mm)) + "mm"),
                  ]),
                ]),
              ]),
              _c("b-col", { attrs: { cols: "auto" } }, [
                _c("p", { staticClass: "mb-0" }, [
                  _c("small", [
                    _vm._v("Depth"),
                    _c("br"),
                    _vm._v(_vm._s(Math.round(_vm.moulding.depth_mm)) + "mm"),
                  ]),
                ]),
              ]),
              _c("b-col", { attrs: { cols: "auto" } }, [
                _c("p", { staticClass: "mb-0" }, [
                  _c("small", [
                    _vm._v("R. Depth"),
                    _c("br"),
                    _vm._v(
                      _vm._s(Math.round(_vm.moulding.rebate_depth_mm)) + "mm"
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm.moulding.is_favourite == 1
        ? _c(
            "div",
            {
              staticClass: "favourite-badge",
              attrs: { title: "One of our favourite mouldings" },
            },
            [_c("span", { staticClass: "material-icons" }, [_vm._v("star")])]
          )
        : _vm._e(),
      !_vm.moulding.in_stock ||
      (_vm.moulding.low_stock && !_vm.moulding.min_order)
        ? _c(
            "div",
            {
              staticClass: "stock-warning",
              class: {
                out: !_vm.moulding.in_stock,
                low: _vm.moulding.low_stock,
              },
            },
            [
              _vm._v(
                _vm._s(_vm.moulding.in_stock ? `Low` : `Out of`) + " Stock"
              ),
            ]
          )
        : _vm._e(),
      _vm.moulding.min_order > 0 && _vm.moulding.in_stock
        ? _c("div", { staticClass: "min-order" }, [
            _vm._v("Subject to min order: £" + _vm._s(_vm.moulding.min_order)),
          ])
        : _vm._e(),
      _vm.moulding.is_not_recommended
        ? _c("div", { staticClass: "not-recommended" }, [
            _vm._v("Not Recommended"),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }